import { computed, ref, reactive, watch, toRefs } from 'vue';
import { convertXYToGPS } from '@/utils/index.js';
import useDataManagementStore from "@/stores/modules/dataManagement";
import useFlightScheduleStore from "@/stores/modules/flightSchedule";
import useUserManagementStore from "@/stores/modules/userManagement";
import useFlightPlanStore from "@/stores/modules/flightPlan";
import useAlarmStore from "@/stores/modules/alarm";
import BaseImgUpload from '@/components/BaseImgUpload.vue';
import BaseCheckBox from '@/components/BaseCheckBox.vue';
export default {
  components: {
    BaseImgUpload,
    BaseCheckBox
  },
  props: {
    formRule: {
      type: Object,
      default: () => {}
    },
    formSet: {
      type: Array,
      default: () => []
    },
    dialogType: {
      type: String,
      default: ''
    }
  },

  setup(props, {
    emit
  }) {
    const useDataManagement = useDataManagementStore();
    const useFlightSchedule = useFlightScheduleStore();
    const useUserManagement = useUserManagementStore();
    const useFlightPlan = useFlightPlanStore();
    const useAlarm = useAlarmStore();
    let form = ref(null);
    let rule = computed(() => props.formRule);
    let formType = computed(() => props.dialogType);
    let filterForm = reactive({});
    const lonLatData = reactive({
      longitude: '',
      latitude: '',
      lonLatTypeVal: 'DD',
      lonDSM: {
        degree: '',
        minute: '',
        second: ''
      },
      latDSM: {
        degree: '',
        minute: '',
        second: ''
      }
    });
    watch(() => props.formSet, () => {
      Object.assign(filterForm, reactive(getDefaultVal()));
      processMapData();
    }, {
      deep: true,
      immediate: true
    }); // 新增飞行任务，根据飞行器编号选择自动填充飞行器类型

    watch(() => filterForm.flyMachineSer, newVal => {
      filterForm.flyClass = useFlightPlan.purposeMap[newVal];
    }, {
      deep: true,
      immediate: true
    }); // 获取表单初始值

    function getDefaultVal() {
      const formVal = {};

      if (props.formSet) {
        props.formSet.forEach(v => {
          if (v.prop === 'typeName' && v.label === '地面资源类型') {
            v.options = useDataManagement.groundResourcesTypeOptions;
          } else if (v.prop === 'typeName' && v.label === '设施设备类型') {
            v.options = useDataManagement.facilityTypeOptions;
          } else if (v.prop === 'subordinateCompany' && v.label === '飞行器所属公司') {
            v.options = useDataManagement.subordinateCompanyOptions;
          } else if (v.prop === 'flyMachineIds') {
            v.options = useFlightSchedule.relevanceAircraftData;
          } else if (v.prop === 'permissionIds') {
            v.options = useUserManagement.permissionList;
          } else if (v.prop === 'roleName') {
            v.options = useUserManagement.roleOptions;
          } else if (v.prop === 'flyMachineSer') {
            v.options = useFlightPlan.flyMachineSeOption;
          } else if (v.prop === 'resources') {
            v.options = useAlarm.allResourceOptions;
          }

          formVal[v.prop] = v.defaultVal;
        });
        return formVal;
      }
    } // 处理地图经纬度


    function processMapData() {
      if (filterForm?.lon && filterForm?.lat) {
        lonLatData.longitude = filterForm?.lon;
        lonLatData.latitude = filterForm?.lat;
      }
    } // 经纬度格式修改


    function lonLatRadioChange(val) {
      if (val?.includes('DSM') && lonLatData?.longitude) {
        changeCoordsToGPS({
          longitude: lonLatData.longitude,
          latitude: lonLatData.latitude
        });
      }

      lonLatData.lonLatTypeVal = val;
    }

    function changeCoordsToGPS(data) {
      let point = convertXYToGPS([data?.longitude, data?.latitude]);
      lonLatData.lonDSM = point?.[0];
      lonLatData.latDSM = point?.[1];
    } // 获取上传图片数据


    function getSuccessUploadImg(data) {
      filterForm.hasOwnProperty('iconPath') && data.length > 0 && (filterForm.iconPath = data[data.length - 1].toString());
      filterForm.hasOwnProperty('devicePictures') && (filterForm.devicePictures = data.toString());
      filterForm.hasOwnProperty('fileUrl') && (filterForm.fileUrl = data.toString());
    } // 获取上传数据


    function getImportFileData(data) {
      filterForm.fileName = data?.name;
      filterForm.fileUrl = data?.url;
      filterForm.geometry = data?.geometry;
    } // 地图选中飞行站点数据


    function mapSelect(data) {
      emit('mapSelect', data);
    } // 获取多选框选项数据


    function processCheckBoxGroupData(data) {
      filterForm.hasOwnProperty('flyMachineIds') && (filterForm.flyMachineIds = data.toString()); // 关联飞行器设备

      filterForm.hasOwnProperty('permissionIds') && (filterForm.permissionIds = data.toString()); // 用户权限
    }

    const authCodeData = reactive({
      getCodeLoading: false,
      // 验证码按钮加载中状态
      getCodeIng: false,
      // 验证码禁用状态
      countdown: 60,
      // 重新获取验证码时间：一分钟倒计时
      timer: null // 验证码倒计时计时器

    }); // 获取手机验证码

    function getAuthCodeByPhone() {
      form.value.validateField('username', async message => {
        if (message) {
          authCodeData.getCodeLoading = true; // 验证码按钮加载中

          useUserManagement.getAuthCodeByPhone({
            tel: filterForm.username || filterForm.mobile || filterForm.userName
          }).then(res => {
            authCodeData.getCodeLoading = false; // 验证码按钮加载结束

            authCodeData.getCodeIng = true; // 验证码按钮禁用状态
            // 60s倒计时

            authCodeData.countdown = 60;
            authCodeData.timer = setInterval(() => {
              authCodeData.countdown--;

              if (authCodeData.countdown == 0) {
                authCodeData.getCodeIng = false; // 验证码按钮取消禁用

                authCodeData.countdown = 60;
                clearInterval(authCodeData.timer);
              }
            }, 1000);
          }).catch(() => {
            authCodeData.getCodeLoading = false;
            authCodeData.getCodeIng = false;
            authCodeData.countdown = 60;
          });
        }
      });
    }

    return {
      processCheckBoxGroupData,
      mapSelect,
      filterForm,
      rule,
      form,
      lonLatRadioChange,
      getSuccessUploadImg,
      ...toRefs(lonLatData),
      ...toRefs(authCodeData),
      getAuthCodeByPhone,
      getImportFileData,
      formType
    };
  }

};